import { http } from '../../utils/http'

export interface SaveEventUserDto {
    partyEventId: number
    email: string
    alias: string
    attendingStatus: number
}

export const insertEventUserAsync = async (
    eventUser: SaveEventUserDto,
    token: string
) : Promise<boolean>  => {
    const result = await http<SaveEventUserDto, null>({
        method: 'post',
        path: 'EventUsers',
        accessToken: token,
        body: eventUser
    })
    return (result.ok)
}


